module.exports = __webpack_public_path__ + "static/img/goods-200.69e56d3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/s28/pop/goods-200.png
// module id = E5pg
// module chunks = 2